<template lang="html">
  <div class="row">
    <div
      v-for="(item, idx) in data"
      :key="idx"
      class="col-12 col-sm-6 col-md-4 col-lg-3 my-3"
    >
      <CardResource
        v-if="item.description.length"
        :imageURL="baseUrlStorage + item.image"
        :title="item.title"
        :id="item.id"
        :description="item.subtitle"
        :data="item.description"
        buttonText="Ver más"
        :type="item.type"
      />
    </div>
  </div>
</template>
<script>
import CardResource from "./CardResource.vue";
export default {
  props: ["data"],
  inject: ["baseUrlStorage"],
  components: {
    CardResource,
  },
  data() {
    return {
      resources: [
        {
          imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
          title: "Cursos",
          description: "Lorem ipsum dolor sit amet",
          buttonText: "Ver más",
          type: false,
        },
        {
          imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
          title: "Estandares",
          description: "Lorem ipsum dolor sit amet",
          buttonText: "Ver más",
          type: true,
        },
        {
          imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
          title: "Metodos",
          description: "Lorem ipsum dolor sit amet",
          buttonText: "Ver más",
          type: true,
        },
        {
          imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
          title: "Responsabilidad Profesional",
          description: "Lorem ipsum dolor sit amet",
          buttonText: "Ver más",
          type: false,
        },
      ],
    };
  },
};
</script>
<style lang="css" scoped></style>
